import * as Header from '-/Custom/Header';
import { Stack, useLocalSearchParams, useRouter } from 'expo-router';
import Box from '@/components/UI/Box';
import Text from '@/components/UI/Text';
import Icon from '@/components/Unistyles/Icon';
import { type FragmentOf, graphql, readFragment } from '@/gql/graphql';

export const ScheduleDetailToolbarFragment = graphql(/* GraphQL */ `
  fragment ScheduleDetailToolbar on event {
    id
    title
    ... on event @_optional {
      permissions
    }
  }
`);

function ScheduleDetailToolbar({
  fragment,
}: {
  fragment: FragmentOf<typeof ScheduleDetailToolbarFragment> | null | undefined;
}) {
  const { eventId } = useLocalSearchParams<{
    eventId: string;
  }>();

  const { navigate } = useRouter();
  const event = readFragment(ScheduleDetailToolbarFragment, fragment);

  const actions = {
    edit: event?.permissions?.edit,
  };

  const showActions = Object.values(actions).some(Boolean);

  const headerTitle = () => (
    <Header.TitleContainer>
      <Box flex>
        <Text
          flexShrink={1}
          size="xl"
          numberOfLines={1}
          testID="ScreenHeaderPrimaryTitle"
        >
          {event?.title}
        </Text>
        <Box flex direction="horizontal" alignItems="center" space="sm">
          <Icon variant="typographySecondary" name="trophy-outline" size="sm" />
          <Text variant="typographySecondary" size="xs">
            Schedule
          </Text>
        </Box>
      </Box>
    </Header.TitleContainer>
  );

  const headerRight = () =>
    showActions ? (
      <Header.End>
        <Header.ButtonGroup>
          {actions.edit ? (
            <Header.Button
              onPress={() => {
                navigate({
                  pathname: '/event/[eventId]/edit',
                  params: {
                    eventId: eventId,
                  },
                });
              }}
            >
              <Icon name="settings-outline" size="2xl" />
            </Header.Button>
          ) : null}
        </Header.ButtonGroup>
      </Header.End>
    ) : null;

  return (
    <Stack.Screen
      options={{
        headerRight,
        headerTitle,
        title: event?.title || '',
        headerShadowVisible: false,
      }}
    />
  );
}

export default ScheduleDetailToolbar;
